import { render, staticRenderFns } from "./ListAvailableQuestionnairesComponent.vue?vue&type=template&id=2a0057bc&"
import script from "./ListAvailableQuestionnairesComponent.vue?vue&type=script&lang=js&"
export * from "./ListAvailableQuestionnairesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports